<template>
  <a-modal
    title="祺信兑付-付款凭证审批"
    v-model="modalShow"
    width="80%"
    @cancel="close"
    destroyOnClose
  >
    <div class="common-title">即将提交以下祺信的付款凭证</div>
    <div class="table-common common">
      <a-table
        size="middle"
        :columns="columns"
        :row-key="record => record.id"
        :data-source="tableData"
        :pagination="false"
        bordered
        :locale="{ emptyText: '暂无数据' }"
      >
        <template slot="exDay" slot-scope="text">
          {{ text | dateFormat("YYYY-mm-dd") }}
        </template>
        <template slot="pymAmt" slot-scope="text, record">
          {{ record.pymAmt | splitK }}
        </template>
        <template slot="operation" slot-scope="text, record">
          <a
            @click="uploadVoucher(record, 'detail')"
            v-if="record.uploadVoucher"
          >
            查看凭证
          </a>
        </template>
      </a-table>
    </div>
    <uploadVoucherDialog ref="uploadVoucherDialog"/>
    <template slot="footer">
      <a-button class="btn-blue-line" @click="close()">取消</a-button>
      <button-load @clickHandle="openPasswordDialog" type="primary" lable="提交" />
    </template>
    <commonPasswordModal ref="commonPasswordModal" @success="passwordSuccess"/>
  </a-modal>
</template>

<script>
import uploadVoucherDialog from "./uploadVoucherDialog.vue"
import commonPasswordModal from "./common-password-modal.vue"
import { applyPayVoucherApprove } from "@/api/pay.js"
export default {
  components:{ uploadVoucherDialog, commonPasswordModal },
  data() {
    return {
      modalShow: false,
      tableData: [],
      columns: [
        {
          title: "祺信编号",
          dataIndex: "gldId",
          ellipsis: true
        },
        {
          title: "接收方",
          dataIndex: "rcPtyNm"
        },
        {
          title: "付款金额(元)",
          dataIndex: "pymAmt",
          scopedSlots: { customRender: "pymAmt" }
        },
        {
          title: "到期日期",
          width: "100px",
          dataIndex: "exDay",
          scopedSlots: { customRender: "exDay" }
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" }
        }
      ]
    };
  },
  created() {},
  methods: {
    open({ selectedRows }) {
      this.modalShow = true;
      this.tableData = this.utils.deepClone(selectedRows || []);
    },
    close() {
      this.modalShow = false;
      this.tableData = [];
    },
    // 打开凭证的弹窗
    uploadVoucher(record,type){
      this.$refs.uploadVoucherDialog.open({
        record:record,
        type
      })
    },
    openPasswordDialog(btn) {
      this.btn = btn;
      this.$refs.commonPasswordModal.open();
    },
    passwordSuccess(txnPwd){
      applyPayVoucherApprove({
        jsonStr:JSON.stringify(this.tableData),
        txnPwd
      }).then(res => {
        this.btn && this.btn.closeLoad();
        this.$message.success("兑付凭证提交审核成功");
        this.close();
        this.$emit("success");
      }).catch(e => {
        this.btn && this.btn.closeLoad();
      })
    }
  },
  watch: {},
  activated() {}
};
</script>
<style scoped lang="less">
.img-tip {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/bill-payment/voucherApproveDialog.vue